import { render, staticRenderFns } from "./modalAddSponsor.vue?vue&type=template&id=72f55994&"
import script from "./modalAddSponsor.vue?vue&type=script&lang=js&"
export * from "./modalAddSponsor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports